
import { iconFactory } from "../../utils/iconFactory";

export const AlertIcon = iconFactory({
  componentName: 'AlertIcon',
  viewBox: '0 0 32 32',
  title: 'alert',
  g: `<path d="M30.4 27.232l-13.504-23.392c-0.256-0.448-0.576-0.64-0.896-0.64s-0.672 0.224-0.896 0.64l-13.504 23.392c-0.512 0.864-0.128 1.568 0.864 1.568h27.040c1.024 0 1.408-0.704 0.896-1.568zM16 25.152c-0.992 0-1.792-0.8-1.792-1.792s0.8-1.792 1.792-1.792 1.792 0.8 1.792 1.792-0.8 1.792-1.792 1.792zM17.856 19.648h-3.648v-6.4h3.648v6.4z"/>`,
  gThemed: {
    // No themed variants provided
  },
});

export default AlertIcon;
